import { useQuery } from "@tanstack/react-query";
import { useClientContext } from "clients";
import { BaseError } from "core/utils/baseError";

export const adhocQueryKey = "adhocDashboard";

/**
 * Hook for getting the adhoc dashboard for the given account number and context id
 *
 * @param {string} account_number
 * @param {string} context_id
 * @returns {useQuery<string, BaseError>}
 */
const useGetAdhocDashboard = (
  account_number: string,
  context_id: string,
  queryKey?: (string | number)[],
) => {
  const clients = useClientContext();
  return useQuery<string, BaseError>({
    queryKey: queryKey ?? [adhocQueryKey, account_number, context_id],
    queryFn: async () =>
      await clients.management
        .getQuickSightDashboard({ account_number, context_id })
        .then((res) => res.embed_url),
  });
};

export default useGetAdhocDashboard;
